<template>
  <div class="animated fadeIn mb-3">
    <b-row>
      <b-col lg="12"></b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col md="2">
        <span>Zip</span>
      </b-col>
      <b-col
        :md="calculatedColumnWidth"
        v-for="filter in current_seminar.Filters"
        :key="filter.FilterID"
      >
        <div v-if="filter.Age">Age: {{filter.Age}}</div>
        <div v-if="filter.Income">Income: {{filter.Income}}</div>
        <div v-if="filter.Dwelling">Dwelling: {{filter.Dwelling}}</div>
        <div v-if="filter.Ethnicity">Ethnicity: {{filter.Ethnicity}}</div>
        <div v-if="filter.Other">Other: {{filter.Other}}</div>
      </b-col>
      <b-col md="1">
        <span>Total</span>
      </b-col>
    </b-row>
    <b-row class="mt-4" :key="componentKey">
      <b-col lg="12">
        <CurrentZipRow
          v-for="current_zip in current_seminar.Zips"
          :key="current_zip.ZipInSeminarID"
          :current_zip_object="current_zip"
          :seminar_object="current_seminar"
          :row_width="calculatedColumnWidth"
          :myIteration="componentKey"
        />
      </b-col>
    </b-row>
    <b-row class="mt-4" :key="componentKey">
      <b-col lg="12">
        <CurrentZipsTotals
          :current_zips_object="current_seminar.Zips"
          :current_filters_object="current_seminar.Filters"
          :row_width="calculatedColumnWidth"
          :myIteration="componentKey"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CurrentZipRow from "@/components/CustomRowComponents/CurrentZipRow.vue";
import CurrentZipsTotals from "@/components/CustomRowComponents/CurrentZipsTotals.vue";

export default {
  name: "CurrentZipEditor",
  props: {
    seminar_object: { type: Object },
  },
  components: { CurrentZipRow, CurrentZipsTotals },
  data() {
    return {
      current_seminar: this.seminar_object,
      current_zips: [],
      componentKey: 0,
    };
  },
  computed: {
    ...mapState(["seminar", "territory", "zip", "n_user"]),
    CurrentZipLength() {
      return this.$store.state.seminar.seminar_edit.Zips.length;
    },
    calculatedColumnWidth() {
      switch (this.current_seminar.Filters.length) {
        case 3:
          return 3;
        case 4:
          return 2;
        default:
          return 5;
      }
    },
  },
  methods: {
    async refreshZips() {
      await this.$store
        .dispatch("seminar/RefreshZips", this.current_seminar.SeminarID)
        .then((response) => {
          this.current_seminar.Zips = response.data["RefreshZipsResult"];
        });
      this.forceRerender();
    },
    forceRerender() {
      this.componentKey += 1;
    },
  },
  created() {},
  watch: {
    "current_seminar.Filters.length": function () {
      this.refreshZips();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>